import { render } from "./AssetValuation.vue?vue&type=template&id=2f337355&scoped=true"
import script from "./AssetValuation.vue?vue&type=script&lang=js"
export * from "./AssetValuation.vue?vue&type=script&lang=js"

import "./AssetValuation.vue?vue&type=style&index=0&id=2f337355&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f337355"]])

export default __exports__